const apiRoutes = {
  SIGN_UP: "/auth/signUp",
  LOGIN: "/auth/login",
  AUTO_LOGIN: "/auth/attemptAutoLogin",
  LOGOUT: "/auth/logout",
  REFRESH_TOKEN: "/auth/refreshToken",
  VERIFY_EMAIL: "/auth/verifyEmail",
  USER_CART: "/user/cart",
  BULK_UPDATE_CART: "/user/bulk-update-cart",
  OPEN_SHOP: "/shopAdmin/openShop",
  ADMIN_SHOP: "/shopAdmin/shop/:shopId",
  CLOSE_SHOP: "/shopAdmin/shop/:shopId/close",
  REOPEN_SHOP: "/shopAdmin/shop/:shopId/reopen",
  GET_ADMIN_SHOPS: "/shopAdmin/myShops",
  GET_PRODUCT: "/product/:productId",
  GET_FEED: "/feed",
  GET_FEED_CONFIG: "/feed/config",
  GET_FEED_REVIEWS: "/feed/reviews",
  GET_FEED_SHOP_RECOMMENDATIONS: "/feed/shop-recommendations",
  GET_FEED_PEOPLE_RECOMMENDATIONS: "/feed/people-recommendations",
  GOOGLE_AUTH: "/auth/google",
  SEARCH: "/search",
  GET_PRODUCT_REVIEWS: "/products/:productId/reviews",
  GET_SHOP_REVIEWS: "/shops/:shopId/reviews",
  LIKE_REVIEW: "/reviews/:reviewId/like",
  CHECK_HANDLE: "/shop/check-handle",
  GET_PUBLIC_SHOP: "/shop/:shopId",
  GET_SHOP_PRODUCTS: "/shop/:shopId/products",
  GET_PUBLIC_USER: "/user/:userId",
  GET_USER_SHOPS: "/user/:userId/shops",
  GET_USER_FOLLOWERS: "/user/:userId/followers",
  GET_USER_FOLLOWING: "/user/:userId/following",
  GET_SHOP_FOLLOWERS: "/shop/:shopId/followers",
  GET_SHOP_FOLLOWING: "/shop/:shopId/following",
  FOLLOW_USER: "/user/:userId/follow",
  FOLLOW_SHOP: "/user/follow-shop/:shopId",
  ADMIN_PRODUCT: "/shopAdmin/product/:productId",
  CREATE_PRODUCT: "/shopAdmin/shop/:shopId/product",
  REQUEST_EMAIL_CHANGE: "/user/request-email-change",
  CONFIRM_EMAIL_CHANGE: "/user/confirm-email-change",
  REQUEST_PHONE_CHANGE: "/user/request-phone-change",
  CONFIRM_PHONE_CHANGE: "/user/confirm-phone-change",
  ADMIN_DASHBOARD: "/devAdmin/dashboard",
  ADMIN_ANALYTICS_SUMMARY: "/devAdmin/analytics/summary",
  ADMIN_DISPUTES: "/devAdmin/disputes",
  ADMIN_DISPUTE_DETAIL: "/devAdmin/disputes/:orderId",
  ADMIN_RESOLVE_DISPUTE: "/devAdmin/orders/:orderId/resolve-dispute",
  ADMIN_REPORTS: "/devAdmin/reports",
  ADMIN_RESOLVE_REPORT: "/devAdmin/reports/:reportId/resolve",
  ADMIN_USERS: "/devAdmin/users",
  ADMIN_USER_DETAIL: "/devAdmin/users/:userId",
  ADMIN_USER_STATUS: "/devAdmin/users/:userId/status",
  ADMIN_USER_ROLE: "/devAdmin/users/:userId/role",
  ADMIN_SHOPS: "/devAdmin/shops",
  ADMIN_SHOP_DETAIL: "/devAdmin/shops/:shopId",
  ADMIN_ORDERS: "/devAdmin/orders",
  ADMIN_ORDER_DETAIL: "/devAdmin/orders/:orderId",
  ADMIN_PRODUCTS: "/devAdmin/products",
  ADMIN_PRODUCT_DETAIL: "/devAdmin/products/:productId",
  ADMIN_SHOP_STATUS: "/devAdmin/shops/:shopId/status",
  ADMIN_PRODUCT_STATUS: "/devAdmin/products/:productId/status",
  ADMIN_USER_RESET_LIMIT: "/devAdmin/users/:userId/reset-change-limit",
  ADMIN_USER_CLEAR_COOLDOWN: "/devAdmin/users/:userId/clear-deletion-cooldown",
  ADMIN_SHOP_RESET_LIMIT: "/devAdmin/shops/:shopId/reset-change-limit",
  ADMIN_PRODUCT_RESET_LIMIT: "/devAdmin/products/:productId/reset-change-limit",
  ADMIN_VERIFICATIONS: "/devAdmin/verifications",
  ADMIN_VERIFICATION_DETAIL: "/devAdmin/verifications/:userId",
  ADMIN_VERIFICATION_REVIEW: "/devAdmin/verifications/:userId/review",
  ADMIN_USER_FLAG_VERIFICATION: "/devAdmin/users/:userId/flag-verification",
  ADMIN_SHOP_FLAG_VERIFICATION: "/devAdmin/shops/:shopId/flag-verification",
  ADMIN_USER_RECOMMENDATIONS: "/devAdmin/users/:userId/recommendations",
  ADMIN_SHOP_RECOMMENDATIONS: "/devAdmin/shops/:shopId/recommendations",
  ADMIN_SHOP_OFFERS_MODE: "/devAdmin/shops/:shopId/offers-mode",
  ADMIN_PRODUCT_RECOMMENDATIONS: "/devAdmin/products/:productId/recommendations",
  ADMIN_FEEDBACK: "/devAdmin/feedback",
  DELETE_ACCOUNT: "/user/account",
  FEATURE_FLAGS: "/feature-flags",
  APP_CONFIG: "/app-config",
  CURRENCY_RATES: "/app-config/currency-rates",
  ADMIN_FEATURE_FLAGS: "/devAdmin/feature-flags",
  ADMIN_FEATURE_FLAG: "/devAdmin/feature-flags/:key",
  REPORT_ENTITY: "/reports",
  UPDATE_USER_PROFILE: "/user/profile",
  UPLOAD_PROFILE_PHOTO: "/user/profile-photo",
  UPLOAD_COVER_PHOTO: "/user/cover-photo",
  DELETE_PROFILE_PHOTO: "/user/profile-photo",
  DELETE_COVER_PHOTO: "/user/cover-photo",
  ADD_EXPERIENCE: "/user/experience",
  UPDATE_EXPERIENCE: "/user/experience/:experienceId",
  DELETE_EXPERIENCE: "/user/experience/:experienceId",
  SEARCH_INSTITUTIONS: "/institutions",
  ADD_EDUCATION: "/user/education",
  UPDATE_EDUCATION: "/user/education/:educationId",
  DELETE_EDUCATION: "/user/education/:educationId",
  MAILING_LIST_JOIN: "/mailing-list/join",
  JOINED_COUNT: "/waitlist/get-joined-count",
};

export { apiRoutes };
